import React from 'react';
import { useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { ModalProvider } from '@cinch/ui';
import { UserStateContextProvider } from './user-state-context';
import { SocketContextProvider } from './socket-context';
import { CustomerDrawerContextProvider } from './customer-drawer-context';
import { BrowserNotificationsProvider } from './browser-notifications';
import { AgentContextProvider } from './agent-context';
import { CinchAiProvider } from 'components/cinch-ai/cinch-ai-context';
import { NotificationsContextProvider } from './notifications-context';
import { RealtimeContextProvider } from './realtime-context';
import { SoftphoneContextProvider } from './softphone-context';
import { SoftphonePanel } from 'components/softphone/softphone-panel.component';
import { CallPopHost } from 'components/call-pop/call-pop-host.component';
export const ContextProviders = ({
  children
}) => {
  // The library's ModalProvider is router- and Sentry-agnostic: it closes every open
  // modal when locationKey changes (the app's old provider keyed on the location object,
  // so react-router's per-navigation key keeps that behavior) and reports a modal that
  // throws during render through onError instead of unmounting the app (CIN-6428).
  const location = useLocation();
  const reportModalError = (error, info) => Sentry.captureException(error, {
    extra: info
  });
  return <UserStateContextProvider>
      <NotificationsContextProvider>
        <SocketContextProvider>
          <AgentContextProvider>
            {/* Cinch AI v2 (CINCHAI-108): the bubble, window and Cinch AI page share this state. */}
            <CinchAiProvider>
              {/* Above CustomerDrawerContextProvider on purpose: that provider renders the
                customer drawer as a SIBLING of children, so anything nested below it is
                invisible to the drawer. The drawer's Dial button reads this context. */}
              <SoftphoneContextProvider>
                <CustomerDrawerContextProvider>
                  {/* Inside CustomerDrawerContextProvider so a realtime event can open the drawer. */}
                  <RealtimeContextProvider>
                    <ModalProvider locationKey={location.key || `${location.pathname}${location.search}`} onError={reportModalError}>
                      <BrowserNotificationsProvider>{children}</BrowserNotificationsProvider>
                    </ModalProvider>
                    {/* Inside RealtimeContextProvider for the call events, and the drawer for Customer details. */}
                    <CallPopHost />
                  </RealtimeContextProvider>
                </CustomerDrawerContextProvider>
                <SoftphonePanel />
              </SoftphoneContextProvider>
            </CinchAiProvider>
          </AgentContextProvider>
        </SocketContextProvider>
      </NotificationsContextProvider>
    </UserStateContextProvider>;
};